__turbopack_context__.v({
  "className": "manrope_470cde7c-module__q3L-nG__className",
  "variable": "manrope_470cde7c-module__q3L-nG__variable",
});
